import ActionTypes from "../constants/ActionTypes";
import actions from "../actions/";
import { getUserNonce } from "../api";
// import cookie from "../utils/cookie";

const initialFetchAllRequest = () => ({
    type: ActionTypes.INITIAL_FETCH_ALL_REQUEST,
});

const initialFetchAllSuccess = () => ({
    type: ActionTypes.INITIAL_FETCH_ALL_SUCCESS,
});

const initialFetchAllFail = error => ({
    type: ActionTypes.INITIAL_FETCH_ALL_FAIL,
    error,
});

export const initialFetchAll = () => dispatch => {
    dispatch(initialFetchAllRequest());

    return getUserNonce().then(() => {
        return Promise.all([
            dispatch(actions.fetchOptions()),
            dispatch(actions.getCart()),
            // dispatch(actions.fetchTagsCounter()),
            // dispatch(actions.fetchContentTags()),
        ])
            .then(() => {
                // attempt to get user info (log in check that will set loggedIn in user state)
                return dispatch(actions.getProfile(true));
            })
            .then(() => {
                dispatch(initialFetchAllSuccess());
            })
            .catch(error => {
                dispatch(initialFetchAllFail(error));
            });
    });
};
